import {FC, useContext} from 'react';
import LoginForm from "../../component/Authorization/Login/LoginForm";
import {Context} from "../../index";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router-dom";
import Confirmation from "../../component/Authorization/Confirmation/Confirmation";

const Login: FC = () => {
    const {store} = useContext(Context);
    const navigate = useNavigate();

    if (!store.isAuth) {
        return (
            <div>
                <LoginForm/>
            </div>
        )
    } else if (!store.isActivate) {
        return (
            <div>
                <Confirmation/>
            </div>
        );
    } else {
        navigate("/projects");
        return null;
    }
}

export default observer(Login);